import React from 'react';

import {useSafeImageSrc} from '../../../../../elements/SafeImage';
import ContainedImage from '../../../../../elements/ContainedImage';
import Initials from './Initials/Initials';
import Link from '../../../../../elements/Link';

function unMaximizeSidepanel() {
    app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
}

export const useBubbleFaceImageSrc = user => {
    const image_url = useSafeImageSrc(user.image_url);
    if (image_url && !image_url.match(/no_avatar/)) {
        return image_url;
    }
    return null;
};

const BubbleFace = props => {
    const {className, user, event} = props,
        image_url = useBubbleFaceImageSrc(user),
        userProfile = ['/events', event.id, '/participants', user.user_id || '-', user.participant_id || '-'].join('/');

    return (
        <Link href={userProfile} onClick={unMaximizeSidepanel}>
            {image_url ? (
                <ContainedImage className={className} src={image_url} altSrc={'/img/no_avatar.png'} />
            ) : (
                <Initials className={className} user={user} />
            )}
        </Link>
    );
};

export default BubbleFace;
